import type { Epic } from 'Flux/index.js'
import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from 'Framework/Epic/ServerNotAvailable.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'

export const CreateDatasetEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.createSamplepoolRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      OrderRepository.createSamplePool(action.payload as any, state.authentication.user).pipe(
        mergeMap((response) => of(order.createSamplepoolSuccess(response))),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.createSamplePoolFailure({ error }))
          })
        )
      )
    )
  )
